// Typelizer digest 1dfd0f0ac22ec8aeba5787e30193e7a7
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** POST /c/:company_id/ledger/counterparties/:counterparty_id/confirmation */
  create: (
    params: { counterpartyId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/ledger/counterparties/:counterparty_id/confirmation', params, options),
    method: 'post',
  }),
}
